import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  TextField,
  Autocomplete,
  autocompleteClasses,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import useStyles from "./styles";
import { Colors, CommonFonts } from "@/theme";

const ProductPicker = (props) => {
  const { products, product, onChange } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box>
      <span className={classes.selectText}>
        {t("dashboard_screen.select_product")}
      </span>
      <Autocomplete
        isOptionEqualToValue={(option, value) => option.id === value.id}
        className={classes.selectContainer}
        options={products}
        getOptionLabel={(option) => option.product_code}
        getOptionKey={(option) => option.id}
        renderInput={(params) => <TextField {...params} />}
        popupIcon={<ExpandMoreIcon sx={{ color: Colors.GRAY_DARK }} />}
        value={product}
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
        disableClearable
        blurOnSelect
        renderOption={(props, option, state, ownerState) => (
          <Box
            sx={{
              [`&.${autocompleteClasses.option}`]: {
                padding: "8px",
                ...CommonFonts.darkBoldFont22,
              },
            }}
            component="li"
            {...props}
          >
            {ownerState.getOptionLabel(option)}
          </Box>
        )}
      />
    </Box>
  );
};

export default ProductPicker;
